import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { base64ToArrayBuffer, saveByteArray } from "utils";
import ComplianceAuditReport from "./ComplianceAuditReport";
import { getApproverUpdatesGridData, getComplianceModificationReport, getcomplianceAuditExportExcel, setcomplianceAuditExportExcel } from "Store/OrderManagement/ComplainceReport/ComplainceReportAction";
import { getApprovalListAssignment } from "Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentAction";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors";
import permissions, { isAuthorized } from "client/utils/Permissions";
import TickIcon from 'client/CommonComponents/Icons/TickIcon';

const ApprovalHistoryDetails = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id, entitytype, date } = useParams();

  //selectors
  const {
    complianceModificationReport,
    approvalListAssignement,
    approverUpdatesGridData,
    userDetails,
    complianceAuditExportExcel,
    isMyOrdersGridLoading
  }: any = useSelector((state: any) => ({
    complianceModificationReport: state.ComplianceReportReducer.complianceModificationReport,
    approvalListAssignement: state?.ApprovalListAssignmentReducer?.approvalListAssignement,
    approverUpdatesGridData: state?.ComplianceReportReducer?.approverUpdatesGridData,
    userDetails: userProfileSelectors.getUserDetails(state),
    complianceAuditExportExcel: state?.ComplianceReportReducer?.complianceAuditExportExcel,
    isMyOrdersGridLoading: state.TransferGridReducer.isMyOrdersGridLoading,
  }))

  const [showAuditGrid, setShowAuditGrid] = useState(false)

  useEffect(() => {
    if ((!isAuthorized(permissions.ViewHierarchy) && !isAuthorized(permissions.ViewComplianceReport)) && userDetails?.permissions) {
      navigate(`/ordermanagement`)
    }
  },[userDetails?.permissions])

  useEffect(() => {
    setShowAuditGrid(false)
    if(id && entitytype && date && (isAuthorized(permissions.ViewHierarchy) || isAuthorized(permissions.ViewComplianceReport))){
      dispatch(getApprovalListAssignment({
        entityId: id,
        entityType: entitytype
      }))
      dispatch(getComplianceModificationReport({
        entityId: id,
        modifiedOn: date?.toString(),
        entityType: entitytype
      }))
      dispatch(getApproverUpdatesGridData({
        entityId: id,
        modifiedOn: date?.toString()
      }))
    }
  }, [id, userDetails?.permissions])

  useEffect(() => {    
    if(complianceModificationReport?.length > 0 || approverUpdatesGridData?.length > 0 || approvalListAssignement?.length > 0){
      setShowAuditGrid(true)
    }else{
      setShowAuditGrid(false)
    }
  },[complianceModificationReport, approverUpdatesGridData, approvalListAssignement])

  useEffect(() => {
    if (complianceAuditExportExcel) {
      const byteArray = base64ToArrayBuffer(complianceAuditExportExcel)
      saveByteArray('Compliance_Audit_Detail', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      dispatch(setcomplianceAuditExportExcel(null))
    }
  }, [complianceAuditExportExcel])


  const approvalHierarchyColumns = [
    {
      key: "stepNumber",
      title: "Approver #",
      width: 190
    },
    {
      key: "title",
      title: "Title",
      width: 190
    },
    {
      key: "userName",
      title: "Approver",
      width: 190
    },
    {
      key: "isRequisition",
      title: "Requisitions",
      Cell: (row: any) => {
        return (
          row?.rowData?.isRequisition ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isDisposition",
      title: "Dispositions",
      Cell: (row: any) => {
        return (
          row?.rowData?.isDisposition ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isSendingTransfer",
      title: "Sending Transfers",
      Cell: (row: any) => {
        return (
          row?.rowData?.isSendingTransfer ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isReceivingTransfer",
      title: "Receiving Transfers",
      Cell: (row: any) => {
        return (
          row?.rowData?.isReceivingTransfer ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isReactivation",
      title: "Reactivations",
      Cell: (row: any) => {
        return (
          row?.rowData?.isReactivation ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isAFEFleet",
      title: "AFE - Fleet",
      Cell: (row: any) => {
        return (
          row?.rowData?.isAFEFleet ? <TickIcon /> : null
        );
      },
      width: 180
    },
    {
      key: "isAFENonFleet",
      title: "AFE - NonFleet",
      Cell: (row: any) => {
        return (
          row?.rowData?.isAFENonFleet ? <TickIcon /> : null
        );
      },
      width: 180
    }
  ];

  const hierarchyModificationColumns = [
    {
      key: "approver",
      title: "Approver #",
      width: 190
    },
    {
      key: "element",
      title: "Element",
      width: 190
    },
    {
      key: "action",
      title: "Action",
      width: 190
    },
    {
      key: "processType",
      title: "Process Type",
      Cell: (row: any) => {
        return (
          <>
            {row.rowData.processType == 'Transfer' ? 'Sending Transfer' : row.rowData.processType}
            </>
        )
    },
      width: 180
    },
    {
      key: "oldValue",
      title: "Old Value",
      width: 180
    },
    {
      key: "newValue",
      title: "New Value",
      width: 180
    },
    {
      key: "updatedDate",
      title: "Updated Date (PST)",
      width: 190
    },
    {
      key: "updatedBy",
      title: "Updated By",
      width:180
    }
  ];

  const breadcrumlist = [
    { text: 'Approval Management', key: 'f1', href: '/ordermanagement/approval', onClick: (e: any) => { e.preventDefault(); navigate("/ordermanagement/approval") } },
    { text: 'Compliance Audit', key: 'f2', href: '/ordermanagement/approval', onClick: (e: any) => { e.preventDefault(); navigate("/ordermanagement/approval") } },
    { text: 'Compliance Audit Detail', key: 'f3' },
  ]


  const onAuditExportExcel = (e: any) => {
    e?.preventDefault();
    dispatch(getcomplianceAuditExportExcel({
      id: id,
      type: entitytype,
      modifiedOn: date?.toString()
    }))
  }

  return (
    <ComplianceAuditReport
      onAuditExportExcel={onAuditExportExcel}
      breadcrumlist={breadcrumlist}
      approvalHierarchyColumns={approvalHierarchyColumns}
      hierarchyModificationColumns={hierarchyModificationColumns}
      complianceModificationReport={complianceModificationReport}
      approvalListAssignement={approvalListAssignement}
      modificationServerTotal={complianceModificationReport?.length ?? 0}
      approverUpdateServerTotal={approverUpdatesGridData?.length ?? 0}
      approverUpdatesGridData={approverUpdatesGridData}
      showAuditGrid = {showAuditGrid}
      isMyOrdersGridLoading = {isMyOrdersGridLoading}
    />
  )
}

export default ApprovalHistoryDetails